module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    staticClass: "ts-switch",
    class: {
      'is-disabled': _vm.disabled, 'is-checked': _vm.checked, 'ts-switch--wide': _vm.hasText
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.disabled),
      expression: "disabled"
    }],
    staticClass: "ts-switch--mask"
  }), _vm._v(" "), _c('input', {
    ref: "input",
    staticClass: "ts-switch--input",
    attrs: {
      "type": "checkbox",
      "name": _vm.name,
      "disabled": _vm.disabled,
      "true-value": _vm.onValue,
      "false-value": _vm.offValue
    },
    on: {
      "change": _vm.handleChange
    }
  }), _vm._v(" "), _c('span', {
    ref: "core",
    staticClass: "ts-switch--core",
    style: ({
      'width': (_vm.coreWidth + "px")
    })
  }, [_c('span', {
    staticClass: "ts-switch--button",
    style: ({
      transform: _vm.transform
    })
  })]), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "label-fade"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.checked),
      expression: "checked"
    }],
    staticClass: "ts-switch--label left",
    style: ({
      'width': (_vm.coreWidth + "px")
    })
  }, [(_vm.onText) ? _c('span', [_vm._v(_vm._s(_vm.onText))]) : _vm._e()])]), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "label-fade"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.checked),
      expression: "!checked"
    }],
    staticClass: "ts-switch--label right",
    style: ({
      'width': _vm.coreWidth + 'px'
    })
  }, [(_vm.offText) ? _c('span', [_vm._v(_vm._s(_vm.offText))]) : _vm._e()])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?{"id":"data-v-2aefeb00"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/Components/common/tsSwitch.vue
// module id = 814
// module chunks = 39